import { Button } from '@rio-cloud/rio-uikit';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import { NameInputChange } from '../../../screens/Expenses';
import { useEffect, useState } from 'react';
import InputSelect from '../Receipt/select';
import { getCategories } from '../../../services';


interface Props {
    show: boolean;
    onClose: () => void;
    onSave: (value: string, selectCategory?: string, selectType?: string) => void;
    title: string;
    placeholder: string;
    name?: string;
    type?: string;
    expenseType?: string;
}

const categoryOptions = [
    { id: '', label: '' },
];

const typeOptions = [
    { id: 'DESPESA', label: 'Despesa' },
    { id: 'RECEITA', label: 'Receita' },
];

interface IcategoryOptionsProps {
    id: string;
    label: string;
}


const DialogCreateCategorySetttings = ({ show, onClose, onSave, title, placeholder, name, type, expenseType }: Props) => {
    const [error, setError] = useState('');
    const [errorCategorySelect, setErrorCategorySelect] = useState('');
    const [errorTypeSelect, setErrorTypeSelect] = useState('');

    const [selectType, setSelectType] = useState('');
    const [selectCategory, setSelectCategory] = useState('');
    const [selectCategoryOptions, setSelectCategoryOptions] = useState<IcategoryOptionsProps[]>(categoryOptions);
    const [valueCategory, setValueCategory] = useState(name || '');

    useEffect(() => {

        setSelectType(type ?? "");
        setSelectCategory(expenseType ?? "");
        setValueCategory(name ?? "");        

    }, [name, type, expenseType, show]);

    const fetchCategories = async () => {
        try {
            const response = await getCategories();

            const filtered = response
              .filter((res: {type: 'RECEITA' | 'DESPESA'}) => res.type === selectType)
              .map((item: any) => ({id: String(item.id), label: item.name}));

            setSelectCategoryOptions(filtered)
        } catch (error) {
            console.log(`error`, error)
        }
    };

    useEffect(() => {
        fetchCategories()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectType])

    const handleSubmit = () => {
        if(!valueCategory || !selectType || !selectCategory) {
            if (!valueCategory) {
                setError('Campo obrigatório')
            } 
            if (!selectType) {
                setErrorTypeSelect('Campo obrigatório')
            }
            if (!selectCategory) {
                setErrorCategorySelect('Campo obrigatório')
            }
            return 
        }

        setError('');
        setErrorTypeSelect('');
        setErrorCategorySelect('')
        
        setValueCategory('')
        setSelectCategory('')
        setSelectType('')

        onSave(valueCategory, selectCategory, selectType);
    }

    const handleClose = () => {
        onClose();
        setValueCategory('')
        setSelectCategory('')
        setSelectType('')

        setError('');
        setErrorTypeSelect('');
        setErrorCategorySelect('')
    }

     const inputChange = (name: NameInputChange, value?: string) => {
        setSelectCategory(value || '');
     }

     const typeCategoryChange = (name: NameInputChange, value?: string) => {     
        setSelectType(value || '');
     }

    return (
        <Dialog
            show={show}
            title={<span className='text-medium text-size-16'>{title}</span>}
            body={
                <>
                     <div className={`form-group ${errorTypeSelect ? "has-feedback has-error" : ""}`}>
                        <InputSelect
                            inputChange={typeCategoryChange}
                            label='Qual o tipo da nova subcategoria?'
                            name='category'
                            onCreateNewOption={() => {}}
                            options={typeOptions}
                            value={selectType}
                            errorMessage={errorTypeSelect}
                        />
                    </div>

                    <div className={`form-group ${errorCategorySelect ? "has-feedback has-error" : ""}`}>
                        <InputSelect
                            inputChange={inputChange}
                            label='Qual a categoria?'
                            name='category'
                            onCreateNewOption={() => {}}
                            options={selectCategoryOptions}
                            value={selectCategory}
                            errorMessage={errorCategorySelect}
                        />
                    </div>

                    <div className={`form-group ${error ? "has-feedback has-error" : ""}`}>
                        <label htmlFor="inputValue">
                            <span>{placeholder}</span>
                        </label>
                        <div className="input-group">
                            <input id="inputValue" type="text" className="form-control" value={valueCategory} onChange={(e) => setValueCategory(e.target.value)} name="value" />
                        </div>
                        {error ? (
                            <span className="form-control-feedback rioglyph rioglyph-error-sign">
                            </span>
                        ) : null}
                        <span className="help-block">
                            <span>{error}</span>
                        </span>
                    </div>
                </>
            }
            onClose={handleClose}
            footer={
                <div className='display-flex align-items-center justify-content-end gap-10'>
                    <Button onClick={handleClose} className='width-150 rounded-small'>Cancelar</Button>
                    <Button onClick={handleSubmit} bsStyle={Button.PRIMARY} className='width-150 rounded-small'>Salvar</Button>
                </div>
            }
            showCloseButton
        />
    )
}

export default DialogCreateCategorySetttings;